var swiper = {};

Vendd.Scripts.load(function () {
    initSwiperSlider('newsBoxes', '.news-slider', {
        slidesPerView: 1, loop: true
    });
    initSwiperSlider('instagramBoxes', '.x-instagram-feed .instagram-list', {
        slidesPerView: 2, slidesPerGroup: 2, breakpoints: { 1920: { slidesPerView: 6, slidesPerGroup: 6 }, 1200: { slidesPerView: 5, slidesPerGroup: 5 }, 768: { slidesPerView: 4, slidesPerGroup: 4 }, 480: { slidesPerView: 3, slidesPerGroup: 3 } }
    });

    initSwiperSlider('blogArticleBoxes', '.blog-details-page .main-article-list-two', {
        slidesPerView: 1,
        slidesPerGroup: 2,
        spaceBetween: 0,

        grid: {
            rows: 2,
            fill: 'column'
        },

        breakpoints: {
            960: {
                slidesPerView: 2,
                slidesPerGroup: 2,
                spaceBetween: 19,
                grid: {
                    rows: 1
                }
            }
        }
    });

    initSwiperSlider('categoryBrandBoxes', '.category-list-page .brands-slider', {
        slidesPerView: 1, breakpoints: { 1200: { slidesPerView: 4, slidesPerGroup: 4 }, 768: { slidesPerView: 3, slidesPerGroup: 3 }, 480: { slidesPerView: 2, slidesPerGroup: 2 } }
    });
    initSwiperSlider('manufacturerBoxes', '.manufacturer-list-page .brands-slider', {
        slidesPerView: 1, breakpoints: { 1200: { slidesPerView: 5, slidesPerGroup: 5 }, 768: { slidesPerView: 2, slidesPerGroup: 2 }, 480: { slidesPerView: 1, slidesPerGroup: 1 } }
    });
    initSwiperSlider('categoryBestBoxes', '.category-list-page .best-products-container .x-product-slider .x-product-list', {
        slidesPerView: 2, slidesPerGroup: 2, spaceBetween: 10, breakpoints: {
            960: { slidesPerView: 3, slidesPerGroup: 3, spaceBetween: 15 }, 1200: { slidesPerView: 2, slidesPerGroup: 2, spaceBetween: 15 }, 1300: { slidesPerView: 3, slidesPerGroup: 3, spaceBetween: 15 }
        },
        navigation: { nextEl: ".category-list-page .best-products-container .swiper-button-next", prevEl: ".category-list-page .best-products-container .swiper-button-prev" },
        pagination: { el: ".category-list-page .best-products-container .swiper-pagination", clickable: true }
    });
    initSwiperSlider('categoryNewBoxes', '.category-list-page .new-products-container .x-product-slider .x-product-list', {
        slidesPerView: 2, slidesPerGroup: 2, spaceBetween: 10, breakpoints: {
            960: { slidesPerView: 3, slidesPerGroup: 3, spaceBetween: 15 }, 1200: { slidesPerView: 2, slidesPerGroup: 2, spaceBetween: 15 }, 1300: { slidesPerView: 3, slidesPerGroup: 3, spaceBetween: 15 }
        },
        navigation: { nextEl: ".category-list-page .new-products-container .swiper-button-next", prevEl: ".category-list-page .new-products-container .swiper-button-prev" },
        pagination: { el: ".category-list-page .new-products-container .swiper-pagination", clickable: true }
    });
    var $bannersSlider = $('.home-page .banners-container .x-banners-slider');
    var $bannersWrapper = $bannersSlider.find('.swiper-wrapper');
    var $originalSlides = $bannersWrapper.children('.swiper-slide').clone(true, true);
    var bannersSlidesCount = $originalSlides.length;

    if (bannersSlidesCount > 1 && !$bannersSlider.hasClass('loop-ready')) {
        $bannersWrapper.empty();

        $bannersWrapper.append($originalSlides.clone(true, true).addClass('fake-slide'));
        $bannersWrapper.append($originalSlides.clone(true, true));
        $bannersWrapper.append($originalSlides.clone(true, true).addClass('fake-slide'));

        $bannersSlider.addClass('loop-ready');
    }


    var ww = $(window).outerWidth();
    var initialized960 = false;

    if (ww > 959) {
        initSwiperSlider('packageBoxes', '.home-page .packages-container .x-product-slider .x-product-list', {
            slidesPerView: 4, slidesPerGroup: 4, spaceBetween: 15, breakpoints: {
                960: { slidesPerView: 3, slidesPerGroup: 3 }, 1300: { slidesPerView: 4, slidesPerGroup: 4 }
            },
            navigation: { nextEl: ".packages-list .swiper-button-next", prevEl: ".packages-list .swiper-button-prev" },
            pagination: { el: ".packages-list .packages-pagination", clickable: true }
        });
        initSwiperSlider('countDownBoxes', '.home-page .countdown-container.with-countdown .x-product-slider .x-product-list', {
            slidesPerView: 3, slidesPerGroup: 3, spaceBetween: 15, breakpoints: {
                1200: { slidesPerView: 2, slidesPerGroup: 2 }, 1300: { slidesPerView: 3, slidesPerGroup: 3 }
            },
            navigation: { nextEl: ".countdown-list .swiper-button-next", prevEl: ".countdown-list .swiper-button-prev" },
            pagination: { el: ".countdown-list .countdown-pagination", clickable: true }
        });
        initSwiperSlider('firstHomeList', '.home-page .first-list .x-product-slider .x-product-list', {
            slidesPerView: 3, slidesPerGroup: 3, spaceBetween: 15, breakpoints: {
                1200: { slidesPerView: 2, slidesPerGroup: 2 }, 1300: { slidesPerView: 3, slidesPerGroup: 3 }
            },
            navigation: { nextEl: ".first-list .swiper-button-next", prevEl: ".first-list .swiper-button-prev" },
            pagination: { el: ".first-list .first-pagination", clickable: true }
        });
        initSwiperSlider('secondHomeList', '.home-page .second-list .x-product-slider .x-product-list', {
            slidesPerView: 3, slidesPerGroup: 3, spaceBetween: 15, breakpoints: {
                1200: { slidesPerView: 2, slidesPerGroup: 2 }, 1300: { slidesPerView: 3, slidesPerGroup: 3 }
            },
            navigation: { nextEl: ".second-list .swiper-button-next", prevEl: ".second-list .swiper-button-prev" },
            pagination: { el: ".second-list .second-pagination", clickable: true }
        });
        initSwiperSlider('bannersSlider', '.home-page .banners-container  .x-banners-slider ', {
            slidesPerView: 'auto', spaceBetween: 15, centeredSlides: true, loop: false, initialSlide: bannersSlidesCount,
            navigation: { nextEl: ".banners-container .swiper-button-next", prevEl: ".banners-container .swiper-button-prev" },
            on: {
                slideChangeTransitionEnd: function () {
                    if (this.activeIndex >= bannersSlidesCount * 2) {
                        this.slideTo(this.activeIndex - bannersSlidesCount, 0, false);
                    }

                    if (this.activeIndex < bannersSlidesCount) {
                        this.slideTo(this.activeIndex + bannersSlidesCount, 0, false);
                    }
                }
            }
        });
        initSwiperSlider('pdSuggestions', '.product-details-region .suggestions .x-product-slider .x-product-list', {
            slidesPerView: 2, slidesPerGroup: 2, spaceBetween: 10, breakpoints: {
                960: { slidesPerView: 3, slidesPerGroup: 3, spaceBetween: 15 }, 1200: { slidesPerView: 3, slidesPerGroup: 3, spaceBetween: 15 }, 1300: { slidesPerView: 4, slidesPerGroup: 4, spaceBetween: 15 }
            },
            navigation: { nextEl: ".product-details-region .suggestions .swiper-button-next", prevEl: ".product-details-region .suggestions .swiper-button-prev" },
            pagination: { el: ".product-details-region .suggestions .swiper-pagination", clickable: true }
        });
        initSwiperSlider('pdSameColors', '.product-details-region .same-colors .x-product-slider .x-product-list', {
            slidesPerView: 2, slidesPerGroup: 2, spaceBetween: 10, breakpoints: {
                960: { slidesPerView: 3, slidesPerGroup: 3, spaceBetween: 15 }, 1200: { slidesPerView: 3, slidesPerGroup: 3, spaceBetween: 15 }, 1300: { slidesPerView: 4, slidesPerGroup: 4, spaceBetween: 15 }
            },
            navigation: { nextEl: ".product-details-region .same-colors .swiper-button-next", prevEl: ".product-details-region .same-colors .swiper-button-prev" },
            pagination: { el: ".product-details-region .same-colors .swiper-pagination", clickable: true }
        });
        initSwiperSlider('offerBoxes', '.home-page .countdown-container.offers .x-product-slider .x-product-list', {
            slidesPerView: 3, slidesPerGroup: 3
        });
        initSwiperSlider('manufacturerDetailsBoxes', '.manufacturer-details-page .x-product-slider .x-product-list', {
            slidesPerView: 4, slidesPerGroup: 4
        });
      
      
        initSwiperSlider('detailsTabBoxes', '.product-details-region .tab-content .x-product-slider .x-product-list', {
            slidesPerView: 1, slidesPerGroup: 1, breakpoints: { 1200: { slidesPerView: 2, slidesPerGroup: 2 } }
        });
        initSwiperSlider('detailsRelatedBoxes', '.product-details-region .related-products-container .x-product-slider .x-product-list', {
            slidesPerView: 4, slidesPerGroup: 4, breakpoints: { 1200: { slidesPerView: 5, slidesPerGroup: 5 } }
        });
        initSwiperSlider('detailsSeeAlsoBoxes', '.product-details-region .see-also-products-container .x-product-slider .x-product-list', {
            slidesPerView: 4, slidesPerGroup: 4, breakpoints: { 1200: { slidesPerView: 5, slidesPerGroup: 5 } }
        });
        initSwiperSlider('detailsSameColorBoxes', '.product-details-region .same-color-products-container .x-product-slider .x-product-list', {
            slidesPerView: 4, slidesPerGroup: 4, breakpoints: { 1200: { slidesPerView: 5, slidesPerGroup: 5 } }
        });
        initSwiperSlider('detailsCountdownColorBoxes', '.product-details-region .countdown-products-container .x-product-slider .x-product-list', {
            slidesPerView: 4, slidesPerGroup: 4, breakpoints: { 1200: { slidesPerView: 5, slidesPerGroup: 5 } }
        });
        initSwiperSlider('comboOneBoxes', '.combo-template-one .x-product-slider .x-product-list', {
            slidesPerView: 4, slidesPerGroup: 4, breakpoints: { 1200: { slidesPerView: 5, slidesPerGroup: 5 } }
        });
        initSwiperSlider('comboTwoBoxes', '.combo-template-two .x-product-slider .x-product-list', {
            slidesPerView: 4, slidesPerGroup: 4, breakpoints: { 1200: { slidesPerView: 5, slidesPerGroup: 5 } }
        });
        initSwiperSlider('cartBoxes', '.cart-region .x-product-slider .x-product-list', {
            slidesPerView: 3, slidesPerGroup: 3, breakpoints: { 1200: { slidesPerView: 4, slidesPerGroup: 4 } }
        });
        initSwiperSlider('blogDetailsBoxes', '.blog-details-page .x-product-slider .x-product-list', {
            slidesPerView: 3, slidesPerGroup: 3, spaceBetween: 15, breakpoints: { 1300: { slidesPerView: 4, slidesPerGroup: 4 } }
        });

        initialized960 = true;
    }

    $(window).on('resize', function () {

        ww = $(window).outerWidth();

        if (ww > 959) {
            if (initialized960) return;

            initSwiperSlider('packageBoxes', '.home-page .packages-container .x-product-slider .x-product-list', {
                slidesPerView: 4, slidesPerGroup: 4, spaceBetween: 15, breakpoints: {
                    960: { slidesPerView: 3, slidesPerGroup: 3 }, 1300: { slidesPerView: 4, slidesPerGroup: 4 }
                },
                navigation: { nextEl: ".packages-list .swiper-button-next", prevEl: ".packages-list .swiper-button-prev" },
                pagination: { el: ".packages-list .packages-pagination", clickable: true }
            });
            initSwiperSlider('countDownBoxes', '.home-page .countdown-container.with-countdown .x-product-slider .x-product-list', {
                slidesPerView: 3, slidesPerGroup: 3, spaceBetween: 15, breakpoints: {
                    1200: { slidesPerView: 2, slidesPerGroup: 2 }, 1300: { slidesPerView: 3, slidesPerGroup: 3 }
                },
                navigation: { nextEl: ".countdown-list .swiper-button-next", prevEl: ".countdown-list .swiper-button-prev" },
                pagination: { el: ".countdown-list .countdown-pagination", clickable: true }
            });
            initSwiperSlider('firstHomeList', '.home-page .first-list .x-product-slider .x-product-list', {
                slidesPerView: 3, slidesPerGroup: 3, spaceBetween: 15, breakpoints: {
                    1200: { slidesPerView: 2, slidesPerGroup: 2 }, 1300: { slidesPerView: 3, slidesPerGroup: 3 }
                },
                navigation: { nextEl: ".first-list .swiper-button-next", prevEl: ".first-list .swiper-button-prev" },
                pagination: { el: ".first-list .first-pagination", clickable: true }
            });
            initSwiperSlider('secondHomeList', '.home-page .second-list .x-product-slider .x-product-list', {
                slidesPerView: 3, slidesPerGroup: 3, spaceBetween: 15, breakpoints: {
                    1200: { slidesPerView: 2, slidesPerGroup: 2 }, 1300: { slidesPerView: 3, slidesPerGroup: 3 }
                },
                navigation: { nextEl: ".second-list .swiper-button-next", prevEl: ".second-list .swiper-button-prev" },
                pagination: { el: ".second-list .second-pagination", clickable: true }
            });
            initSwiperSlider('bannersSlider', '.home-page .banners-container  .x-banners-slider ', {
                slidesPerView: 'auto', spaceBetween: 15, centeredSlides: true, loop: false, initialSlide: bannersSlidesCount,
                navigation: { nextEl: ".banners-container .swiper-button-next", prevEl: ".banners-container .swiper-button-prev" },
                on: {
                    slideChangeTransitionEnd: function () {
                        if (this.activeIndex >= bannersSlidesCount * 2) {
                            this.slideTo(this.activeIndex - bannersSlidesCount, 0, false);
                        }

                        if (this.activeIndex < bannersSlidesCount) {
                            this.slideTo(this.activeIndex + bannersSlidesCount, 0, false);
                        }
                    }
                }
            });
            initSwiperSlider('pdSuggestions', '.product-details-region .suggestions .x-product-slider .x-product-list', {
                slidesPerView: 2, slidesPerGroup: 2, spaceBetween: 10, breakpoints: {
                    960: { slidesPerView: 3, slidesPerGroup: 3, spaceBetween: 15 }, 1200: { slidesPerView: 3, slidesPerGroup: 3, spaceBetween: 15 }, 1300: { slidesPerView: 4, slidesPerGroup: 4, spaceBetween: 15 }
                },
                navigation: { nextEl: ".product-details-region .suggestions .swiper-button-next", prevEl: ".product-details-region .suggestions .swiper-button-prev" },
                pagination: { el: ".product-details-region .suggestions .swiper-pagination", clickable: true }
            });
            initSwiperSlider('pdSameColors', '.product-details-region .same-colors .x-product-slider .x-product-list', {
                slidesPerView: 2, slidesPerGroup: 2, spaceBetween: 10, breakpoints: {
                    960: { slidesPerView: 3, slidesPerGroup: 3, spaceBetween: 15 }, 1200: { slidesPerView: 3, slidesPerGroup: 3, spaceBetween: 15 }, 1300: { slidesPerView: 4, slidesPerGroup: 4, spaceBetween: 15 }
                },
                navigation: { nextEl: ".product-details-region ..same-colors .swiper-button-next", prevEl: ".product-details-region .same-colors .swiper-button-prev" },
                pagination: { el: ".product-details-region .same-colors .swiper-pagination", clickable: true }
            });
            initSwiperSlider('offerBoxes', '.home-page .countdown-container.offers .x-product-slider .x-product-list', {
                slidesPerView: 3, slidesPerGroup: 3
            });
            initSwiperSlider('manufacturerDetailsBoxes', '.manufacturer-details-page .x-product-slider .x-product-list', {
                slidesPerView: 4, slidesPerGroup: 4
            });
        
           
            initSwiperSlider('detailsTabBoxes', '.product-details-region .tab-content .x-product-slider .x-product-list', {
                slidesPerView: 1, slidesPerGroup: 1, breakpoints: { 1200: { slidesPerView: 2, slidesPerGroup: 2 } }
            });
            initSwiperSlider('detailsRelatedBoxes', '.product-details-region .related-products-container .x-product-slider .x-product-list', {
                slidesPerView: 4, slidesPerGroup: 4, breakpoints: { 1200: { slidesPerView: 5, slidesPerGroup: 5 } }
            });
            initSwiperSlider('detailsSeeAlsoBoxes', '.product-details-region .see-also-products-container .x-product-slider .x-product-list', {
                slidesPerView: 4, slidesPerGroup: 4, breakpoints: { 1200: { slidesPerView: 5, slidesPerGroup: 5 } }
            });
            initSwiperSlider('detailsSameColorBoxes', '.product-details-region .same-color-products-container .x-product-slider .x-product-list', {
                slidesPerView: 4, slidesPerGroup: 4, breakpoints: { 1200: { slidesPerView: 5, slidesPerGroup: 5 } }
            });
            initSwiperSlider('detailsCountdownColorBoxes', '.product-details-region .countdown-products-container .x-product-slider .x-product-list', {
                slidesPerView: 4, slidesPerGroup: 4, breakpoints: { 1200: { slidesPerView: 5, slidesPerGroup: 5 } }
            });
            initSwiperSlider('comboOneBoxes', '.combo-template-one .x-product-slider .x-product-list', {
                slidesPerView: 4, slidesPerGroup: 4, breakpoints: { 1200: { slidesPerView: 5, slidesPerGroup: 5 } }
            });
            initSwiperSlider('comboTwoBoxes', '.combo-template-two .x-product-slider .x-product-list', {
                slidesPerView: 4, slidesPerGroup: 4, breakpoints: { 1200: { slidesPerView: 5, slidesPerGroup: 5 } }
            });
            initSwiperSlider('cartBoxes', '.cart-region .x-product-slider .x-product-list', {
                slidesPerView: 3, slidesPerGroup: 3, breakpoints: { 1200: { slidesPerView: 4, slidesPerGroup: 4 } }
            });
            initSwiperSlider('blogDetailsBoxes', '.blog-details-page .x-product-list', {
                slidesPerView: 3, slidesPerGroup: 3, spaceBetween: 15, breakpoints: { 1300: { slidesPerView: 4, slidesPerGroup: 4 } }
            });

            initialized960 = true;
        } else { 
            if (!initialized960) return;

            destroySwiperSlider('packageBoxes');
            destroySwiperSlider('countDownBoxes');
            destroySwiperSlider('firstHomeList');
            destroySwiperSlider('secondHomeList');
            destroySwiperSlider('bannersSlider');
            destroySwiperSlider('offerBoxes');
            destroySwiperSlider('manufacturerDetailsBoxes');
            destroySwiperSlider('detailsTabBoxes');
            destroySwiperSlider('detailsRelatedBoxes');
            destroySwiperSlider('detailsSeeAlsoBoxes');
            destroySwiperSlider('detailsSameColorBoxes');
            destroySwiperSlider('detailsCountdownColorBoxes');
            destroySwiperSlider('comboOneBoxes');
            destroySwiperSlider('comboTwoBoxes');
            destroySwiperSlider('cartBoxes');
            destroySwiperSlider('blogDetailsBoxes');
            destroySwiperSlider('pdSuggestions');
            destroySwiperSlider('pdSameColors');

            initialized960 = false;
        }

    });

});

var defaultSwiperOptions = {
    slidesPerView: "auto",
    speed: 1200,
    mousewheel: false,
    centeredSlides: false,
    centeredSlidesBounds: false,
    loop: false,
    watchSlidesProgress: true,
    keyboard: { enabled: true },
    pagination: { clickable: true },
    navigation: { }
};

function initSwiperSlider(obj, container, options) {  
    if ($(container).length < 1) return;

    //set unique pagination and navigation of each slider
    defaultSwiperOptions.pagination.el = container + " .swiper-pagination";
    defaultSwiperOptions.navigation.nextEl = container + " .swiper-button-next";
    defaultSwiperOptions.navigation.prevEl = container + " .swiper-button-prev";

    var opts = $.extend({}, defaultSwiperOptions, options);

    // Swiper a11y sets role="group" on every slide, which removes the implicit listitem
    // role and leaves <ul class="swiper-wrapper"> containing non-list children (WCAG 1.3.1).
    // Keep slides as list items whenever the wrapper really is a list.
    if ($(container).find("ul.swiper-wrapper").length) {
        opts.a11y = $.extend({}, opts.a11y, { slideRole: "listitem" });
    }

    swiper[obj] = new Swiper(container, opts);
}

function destroySwiperSlider(obj) {
    if (swiper[obj]) {
        if (!swiper[obj].destroyed) {
            swiper[obj].destroy(true, true);
        }
    }
}